const dev = process.env.NODE_ENV == 'development'

// initial state
export const state = {
  server: dev ? 'http://localhost:8000' : 'https://myapi.vanityart.com',
  vendorList: [],
  subsidiaryList: [],
  vendorSubsidiaryMap: {},
  vendorAccountNumbersMap: {},
  vendorExpenseAccountMap: {},
  myVendors: [],
}

// mutations
export const mutations = {
  setVendorSubsidiary (state, data) {
    var vendorSet = new Set()
    var subsidiarySet = new Set()
    var vendorSubsidiaryMap = {}
    var vendorAccountNumbersMap = {}
    var vendorExpenseAccountMap = {}
    data.forEach(item => {
      vendorSet.add(item.vendor)
      subsidiarySet.add(item.subsidiary)
      vendorSubsidiaryMap[item.vendor] = item.subsidiary
      if (item.accounts) {
        var accounts = item.accounts.split(',').map(a => a.trim()).filter(a => Boolean(a))
        if (accounts.length) {
          vendorAccountNumbersMap[item.vendor] = accounts
        }
      }
      if (item.expenseAccount) {
        var expenseAccount = item.expenseAccount.trim()
        if (expenseAccount) {
          vendorExpenseAccountMap[item.vendor] = expenseAccount
        }
      }
    })
    var vendorList = Array.from(vendorSet)
    vendorList.sort((a, b) => {
      var va = a.substr(a.indexOf(' ') + 1).trim()
      var vb = b.substr(b.indexOf(' ') + 1).trim()
      return va.localeCompare(vb)
    })
    state.vendorList = vendorList
    state.subsidiaryList = Array.from(subsidiarySet)
    state.vendorSubsidiaryMap = vendorSubsidiaryMap
    state.vendorAccountNumbersMap = vendorAccountNumbersMap
    state.vendorExpenseAccountMap = vendorExpenseAccountMap
  },
  setMyVendors (state, data) {
    state.myVendors = data
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
